import type { IconProps } from "./icon-types";

/**
 * 가로 3점(⋯, ellipsis/kebab). 행 끝 더보기(overflow) 트리거 등에서 사용.
 *
 * 글리프는 `react-icons/lu`의 `LuEllipsis`(Lucide `ellipsis`)를 인라인으로 재현 —
 * c6 패키지는 외부 아이콘 라이브러리를 import하지 않으므로(RFC-design-system-split §아이콘).
 * 다른 c6 아이콘과 톤·크기를 맞추기 위해 24 그리드를 사용하되, 점은 fill로 채운다.
 */
export const MoreHorizontalIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <circle cx="5" cy="12" r="1.6" />
    <circle cx="12" cy="12" r="1.6" />
    <circle cx="19" cy="12" r="1.6" />
  </svg>
);
